import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Loading from 'components/shared-components/Loading'
import {
  AUTH_PREFIX_PATH,
  UNAUTHENTICATED_ENTRY,
  REDIRECT_URL_KEY,
} from 'configs/AppConfig'

const ProtectedRoute = () => {
  const { token, loading } = useSelector((state) => state.auth)
  const location = useLocation()

  if (loading && !token) {
    return <Loading cover="content" />
  }

  if (!token) {
    return (
      <Navigate
        to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    )
  }

  return <Outlet />
}

export default ProtectedRoute
